import { render } from "./Info.svg?vue&type=template&id=00330b37"
const script = {}
script.render = render

export default script